var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x align-middle"},[_c('span',{staticClass:"cell total-elo-label auto"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"total-elo-count auto button rounded",class:{
      'bgcolor--primary': _vm.match === _vm.constants.ELO_STATUS.ACTIVE,
      'bgcolor--success': _vm.match === _vm.constants.ELO_STATUS.ATTAINED,
      'bgcolor--alert': _vm.match === _vm.constants.ELO_STATUS.EXEMPTED,
    }},[_vm._v(" "+_vm._s(_vm.eloCount)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }